import highlightElements from './highlight-elements';
import highlighterOffset from './highlighter-offset';

export default {
  highlightElements,
  highlighterOffset,
};
